import { WorkflowTraceSchema } from '@toolproof-core/genesis/zod/workflow-trace';
import type { WorkflowTrace } from '@toolproof-core/genesis/_contract/_index';

import branchFallbackTrace from '@/workflow-runner/_data/curated-traces/branch-fallback.json' with { type: 'json' };
import branchFirstTrace from '@/workflow-runner/_data/curated-traces/branch-first.json' with { type: 'json' };
import branchSecondTrace from '@/workflow-runner/_data/curated-traces/branch-second.json' with { type: 'json' };
import carryAndBorrowTrace from '@/workflow-runner/_data/curated-traces/carry-and-borrow.json' with { type: 'json' };
import incrementingLoopTrace from '@/workflow-runner/_data/curated-traces/incrementing-loop.json' with { type: 'json' };
import countedForLoopTrace from '@/workflow-runner/_data/curated-traces/counted-for-loop.json' with { type: 'json' };
import straightLineTrace from '@/workflow-runner/_data/curated-traces/workflow-trace-straight-line.json' with { type: 'json' };
import { isWorkflowTrace } from '@/workflow-runner/_pure/model/traceHelpers';

const fixtures: unknown[] = [
    straightLineTrace,
    incrementingLoopTrace,
    countedForLoopTrace,
    branchFirstTrace,
    branchSecondTrace,
    branchFallbackTrace,
    carryAndBorrowTrace,
];

export const curatedWorkflowTraces: readonly WorkflowTrace[] = Object.freeze(fixtures.map((fixture) => {
    const trace: unknown = WorkflowTraceSchema.parse(fixture);
    if (!isWorkflowTrace(trace)) throw new Error('Invalid curated WorkflowTrace fixture.');
    return trace;
}));
